import React, { useState } from 'react';
import './WhatsAppWidget.css';

import whatsappImage from '../../assets/img/tm7/whatsapp.png';
import { sanitizeInput } from '../../utils/sanitize';

const WhatsAppWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const handleSendMessage = () => {
    if (message.trim()) {
      const sanitizedMessage = sanitizeInput(message);
      const url = `https://wa.me/905369900797?text=${encodeURIComponent(sanitizedMessage)}`;
      window.open(url, '_blank');
      setMessage('');
      setIsOpen(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (
    <div id="whatsapp" className="whatsapp-widget">
      <div className={`wp-wrapper ${isOpen ? 'active' : ''}`}>
        <div className="wp-close" onClick={() => setIsOpen(false)}></div>
        <div className="wp-detail">
          <div className="user-name jost">
            Thermomix Dünyası <small>Canlı Destek</small>
          </div>
        </div>
        <div className="wp-content" style={{ position: 'relative' }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            width: '100%',
            zIndex: 0,
            opacity: 0.08,
            backgroundImage: `url(${whatsappImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            pointerEvents: 'none'
          }}></div>
          <div className="wp-message-content" style={{ position: 'relative', zIndex: 2 }}>
            <div className="message-user jost">Thermomix Dünyası</div>
            <div className="wp-message jost">Merhaba, size nasıl yardımcı olabilirim?</div>
          </div>
        </div>
        <div className="wp-text">
          <input
            type="text"
            name="wp-message"
            placeholder="Mesajınız"
            className="jost"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button type="button" className="wp-send" onClick={handleSendMessage} aria-label="Mesaj gönder">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path>
            </svg>
          </button>
        </div>
      </div>
      <div className="wp-button" onClick={() => setIsOpen(!isOpen)}>
        <svg viewBox="0 0 90 90" fill="rgb(79, 206, 93)" width="32" height="32">
          <path d="M90,43.841c0,24.213-19.779,43.841-44.182,43.841c-7.747,0-15.025-1.98-21.357-5.455L0,90l7.975-23.522   c-4.023-6.606-6.34-14.354-6.34-22.637C1.635,19.628,21.416,0,45.818,0C70.223,0,90,19.628,90,43.841z M45.818,6.982   c-20.484,0-37.146,16.535-37.146,36.859c0,8.065,2.629,15.534,7.076,21.61L11.107,79.14l14.275-4.537   c5.865,3.851,12.891,6.097,20.437,6.097c20.481,0,37.146-16.533,37.146-36.857S66.301,6.982,45.818,6.982z M68.129,53.938   c-0.273-0.447-0.994-0.717-2.076-1.254c-1.084-0.537-6.41-3.138-7.4-3.495c-0.993-0.358-1.717-0.538-2.438,0.537   c-0.721,1.076-2.797,3.495-3.43,4.212c-0.632,0.719-1.263,0.809-2.347,0.271c-1.082-0.537-4.571-1.673-8.708-5.333   c-3.219-2.848-5.393-6.364-6.025-7.441c-0.631-1.075-0.066-1.656,0.475-2.191c0.488-0.482,1.084-1.255,1.625-1.882   c0.543-0.628,0.723-1.075,1.082-1.793c0.363-0.717,0.182-1.344-0.09-1.883c-0.27-0.537-2.438-5.825-3.34-7.977   c-0.902-2.15-1.803-1.792-2.436-1.792c-0.631,0-1.354-0.09-2.076-0.09c-0.722,0-1.896,0.269-2.889,1.344   c-0.992,1.076-3.789,3.676-3.789,8.963c0,5.288,3.879,10.397,4.422,11.113c0.541,0.716,7.49,11.92,18.5,16.223   C58.2,65.771,58.2,64.336,60.186,64.156c1.984-0.179,6.406-2.599,7.312-5.107C68.398,56.537,68.398,54.386,68.129,53.938z"></path>
        </svg>
      </div>
    </div>
  );
};

export default WhatsAppWidget;

